import Image from '@base/Image';
import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import { useState } from 'react';
import useCertificationCourseData from './useCertificationCourseData';

const Container = styled.div`
  display: grid;
  width: 100%;
  row-gap: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    row-gap: ${Spacings.SPACING_4B};
  }
`;

const Title = styled(Typography)``;

const Description = styled(Typography)`
  color: var(--color-text-primary);
`;

const ImageWrapper = styled.div`
  width: 26px;
  height: 24px;
  position: relative;
  min-width: 26px;
  ${mediaQuery.uptoMobile} {
    min-width: ${Spacings.SPACING_8B};
  }
`;

const CalloutBanner = styled.div`
  margin-top: -${Spacings.SPACING_2B};
  display: flex;
  padding: ${Spacings.SPACING_3B};
  width: 768px;
  height: 64px;
  background: rgba(255, 173, 59, 0.08);
  border-radius: ${Spacings.SPACING_2B};
  gap: ${Spacings.SPACING_14};
  align-items: center;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: auto;
  }
`;

const CalloutText = styled(Typography)``;
const CertificationContainer = styled.div`
  position: relative;
`;
const BackgroundBorder = styled.div`
  border: ${Spacings.SPACING_2} solid;
  position: absolute;
  width: 99%;
  border-radius: ${Spacings.SPACING_4B};
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: 40px;
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;
const CertificateWrapper = styled.div`
  width: 768px;
  height: 428px;
  border-radius: ${Spacings.SPACING_4B};
  position: relative;
  margin-top: ${Spacings.SPACING_2};
  img {
    border-radius: ${Spacings.SPACING_4B};
  }
  ${mediaQuery.uptoMobile} {
    height: 182px;
    width: 100%;
    margin-top: ${Spacings.SPACING_2B};
    border-radius: ${Spacings.SPACING_6};
    img {
      border-radius: ${Spacings.SPACING_6};
    }
  }
`;

const Certification = ({ goalUID }) => {
  const { sections } = useCertificationCourseData(goalUID);
  const certification = sections?.certification ?? {};
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const handlerImageLoad = () => {
    setIsImageLoaded(true);
  };
  return (
    <Container>
      <Title variant="h3">{certification?.programmeCertificationTitle}</Title>
      <Description variant="p2" color="var(--color-text-primary)">
        {certification.programmeCertificationDescription}
      </Description>
      <CalloutBanner>
        <ImageWrapper>
          <Image
            src="certificationCourses/callout-icon.svg"
            layout="fill"
            alt="callout"
          />
        </ImageWrapper>
        <CalloutText variant="p2">
          {certification.programmeCertificationCallout}
        </CalloutText>
      </CalloutBanner>
      <CertificationContainer>
        {isImageLoaded && <BackgroundBorder />}
        <CertificateWrapper>
          <Image
            src={certification.programmeCertificationSampleImage}
            layout="fill"
            alt="certificate"
            onLoadingComplete={handlerImageLoad}
          />
        </CertificateWrapper>
      </CertificationContainer>
    </Container>
  );
};

export default Certification;
